module.exports = __webpack_public_path__ + "img/Beeline_logo.1a21ed2a.jpg";